import { TenantEntity } from '../TenantEntity'

export class TruckingInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'TruckingInfo'
  }
  get truckingId() {
    return this._data.truckingId
  }
  set truckingId(truckingId) {
    this._data.truckingId = truckingId || 0
  }
  get carryingCmp() {
    return this._data.carryingCmp
  }
  set carryingCmp(carryingCmp) {
    this._data.carryingCmp = carryingCmp || 0
  }
  get loadingDate() {
    return this._data.loadingDate
  }
  set loadingDate(loadingDate) {
    this._data.loadingDate = loadingDate
  }
  get driver() {
    return this._data.driver
  }
  set driver(driver) {
    this._data.driver = driver
  }
  get driverTel() {
    return this._data.driverTel
  }
  set driverTel(driverTel) {
    this._data.driverTel = driverTel
  }
  get doorName() {
    return this._data.doorName
  }
  set doorName(doorName) {
    this._data.doorName = doorName
  }
  get doorMan() {
    return this._data.doorMan
  }
  set doorMan(doorMan) {
    this._data.doorMan = doorMan
  }
  get doorManTel() {
    return this._data.doorManTel
  }
  set doorManTel(doorManTel) {
    this._data.doorManTel = doorManTel
  }
  get doorAddr() {
    return this._data.doorAddr
  }
  set doorAddr(doorAddr) {
    this._data.doorAddr = doorAddr
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get truckOrderNo() {
    return this._data.truckOrderNo
  }
  set truckOrderNo(truckOrderNo) {
    this._data.truckOrderNo = truckOrderNo
  }
  get printState() {
    return this._data.printState
  }
  set printState(printState) {
    this._data.printState = printState || 0
  }
  get printDate() {
    return this._data.printDate
  }
  set printDate(printDate) {
    this._data.printDate = printDate
  }
  get printBy() {
    return this._data.printBy
  }
  set printBy(printBy) {
    this._data.printBy = printBy
  }
  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    this._data.plateNumber = plateNumber
  }
  get truckingFee() {
    return this._data.truckingFee
  }
  set truckingFee(truckingFee) {
    this._data.truckingFee = truckingFee || 0
  }
  get sendState() {
    return this._data.sendState
  }
  set sendState(sendState) {
    this._data.sendState = sendState || 0
  }
  get interactiveNo() {
    return this._data.interactiveNo
  }
  set interactiveNo(interactiveNo) {
    this._data.interactiveNo = interactiveNo
  }
  get travelHour() {
    return this._data.travelHour
  }
  set travelHour(travelHour) {
    this._data.travelHour = travelHour || 0
  }
  get travelMinute() {
    return this._data.travelMinute
  }
  set travelMinute(travelMinute) {
    this._data.travelMinute = travelMinute || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  // 所在城市
  get cityCode() {
    return this._data.cityCode
  }
  set cityCode(cityCode) {
    this._data.cityCode = cityCode
  }
  // 托盘数量
  get palletSum() {
    return this._data.palletSum
  }
  set palletSum(palletSum) {
    this._data.palletSum = palletSum || 0
  }
  // 司机名称
  get driverName() {
    return this._data.driverName
  }
  set driverName(driverName) {
    this._data.driverName = driverName
  }
  // 司机电话
  get driverPhone() {
    return this._data.driverPhone
  }
  set driverPhone(driverPhone) {
    this._data.driverPhone = driverPhone
  }
  // 司机名称
  get driverIdCard() {
    return this._data.driverIdCard
  }
  set driverIdCard(driverIdCard) {
    this._data.driverIdCard = driverIdCard
  }
  get relatedDischargingTrucking() {
    return this._data.relatedDischargingTrucking
  }
  set relatedDischargingTrucking(relatedDischargingTrucking) {
    this._data.relatedDischargingTrucking = relatedDischargingTrucking
  }
  get carFormUuid() {
    return this._data.carFormUuid
  }
  set carFormUuid(carFormUuid) {
    this._data.carFormUuid = carFormUuid
  }
}
